import { ApiEventType, ApiAlertSeverity } from '@cbridge-packages/api-notifications';

export type EventType = ApiEventType;

export type AlertSeverity = ApiAlertSeverity;

export interface IAlertRecipient {
  email: string;
  error?: string;
  isSent: boolean;
}

export enum AlertType {
  Connectivity = 'connectivity',
  Ops = 'ops',
  OpsClient = 'opsClient',
  Pricing = 'pricing',
  Risk = 'risk',
  Trading = 'trading',
}

export interface ITriggeredAlert {
  id: number;
  emailSkipped: boolean;
  emailTitle: string;
  eventType: EventType;
  guide?: string;
  message: string;
  recipients: IAlertRecipient[];
  severity: AlertSeverity;
  time: number;
  type: AlertType;
}

export interface IAlertSubscription {
  type: AlertType;
  enabled: boolean;
  recipients: string[];
  cooldownSec: number;
}
